import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class ToolmakerBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.TOOLMAKER;
}

export default ToolmakerBuildingTileEntity;
